module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/manage/assistant/assistant.component.html
// module id = ./src/app/Pages/manage/assistant/assistant.component.html
// module chunks = main